export var Provider;
(function (Provider) {
    Provider["Frisbii"] = "frisbii";
    Provider["MobilePeople"] = "mobile-people";
    Provider["FarPay"] = "farpay";
})(Provider || (Provider = {}));
export var PaymentMethodStatus;
(function (PaymentMethodStatus) {
    PaymentMethodStatus["CREATED"] = "CREATED";
    PaymentMethodStatus["SAVED"] = "SAVED";
    PaymentMethodStatus["DELETED"] = "DELETED";
})(PaymentMethodStatus || (PaymentMethodStatus = {}));
export var PendingPaymentStatus;
(function (PendingPaymentStatus) {
    PendingPaymentStatus["PENDING"] = "PENDING";
    PendingPaymentStatus["APPROVED"] = "APPROVED";
    PendingPaymentStatus["REJECTED"] = "REJECTED";
})(PendingPaymentStatus || (PendingPaymentStatus = {}));
//# sourceMappingURL=index.js.map